/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type ModalViewState = "collapsed" | "mini" | "expanded";

interface ModalState {
  isOpen: boolean;
  modalType: string | null;
  defaultValues?: any | null;
  isCollapsed: boolean;
  isExpanded: boolean;
  isMiniView: boolean;
}

const initialState: ModalState = {
  isOpen: false,
  modalType: null,
  defaultValues: null,
  isCollapsed: false,
  isExpanded: false,
  isMiniView: false,
};

interface OpenModalPayload {
  modalType: string;
  defaultValues?: any;
}

export const modalSlice = createSlice({
  name: "modal",
  initialState,
  reducers: {
    openModal: (state, action: PayloadAction<OpenModalPayload>) => {
      const { modalType, defaultValues = {} } = action.payload;
      state.modalType = modalType as string;
      state.defaultValues = defaultValues;
      state.isOpen = true;
      state.isCollapsed = false;
    },
    closeModal: (state) => {
      state.modalType = null;
      state.defaultValues = null;
      state.isOpen = false;
      state.isCollapsed = false;
      state.isExpanded = false;
      state.isMiniView = false;
    },
    updateModal: (state, action: PayloadAction<Partial<ModalState>>) => {
      if (state.isOpen) {
        if (action.payload.defaultValues !== undefined) {
          state.defaultValues = {
            ...state.defaultValues,
            ...action.payload.defaultValues,
          };
        }
        if (action.payload.modalType !== undefined) {
          state.modalType = action.payload.modalType;
        }
        if (action.payload.isOpen !== undefined) {
          state.isOpen = action.payload.isOpen;
        }
        if (action.payload.isCollapsed !== undefined) {
          state.isCollapsed = action.payload.isCollapsed;
        }
      }
    },
    setCollapsed: (state, action: PayloadAction<boolean>) => {
      if (state.isOpen) {
        state.isCollapsed = action.payload;
      }
    },
    setExpanded: (state, action: PayloadAction<boolean>) => {
      if (state.isOpen) {
        state.isExpanded = action.payload;
      }
    },
    setMiniView: (state, action: PayloadAction<boolean>) => {
      if (state.isOpen) {
        state.isMiniView = action.payload;
      }
    },
    setModalViewState: (state, action: PayloadAction<ModalViewState>) => {
      if (state.isOpen) {
        const viewState = action.payload;
        state.isCollapsed = viewState === "collapsed";
        state.isMiniView = viewState === "mini";
        state.isExpanded = viewState === "expanded";
      }
    },
  },
});

export const {
  openModal,
  closeModal,
  updateModal,
  setCollapsed,
  setExpanded,
  setMiniView,
  setModalViewState,
} = modalSlice.actions;
